import { lazy } from 'react';
import { IRouteConfig } from '../types';

export const usageDetailRoutes = (): IRouteConfig[] => [
  {
    path: '/usage-details',
    exact: true,
    name: '用量明细',
    component: lazy(() => import('@/presentation/pages/usage-details')),
    hideInMenu: true,
  },
];

export default usageDetailRoutes;
